<template>
  <div class="new-oil-recharge-body">
    <div class="new-oil-recharge-nav">
      <navbar
        title="油卡充值"
        :lefticonshow="true"
        :lefticonwidth="9"
        :lefticonheight="16"
        :lefticon="newoilcardbackicon"
        :righticonshow="true"
        :righticon="newoilcardrighticon"
        :righticonheight="16"
        :righticonwidth="16"
        @goback="goBack"
        @rightclick="goPage('/new-oli/cardbind')"
      />
    </div>
    <div class="new-oil-card-div">
      <van-swipe
        class="my-swipe"
        :autoplay="0"
        indicator-color="white"
        @change="changeCardIndex"
        :initial-swipe="activation_card_index"
      >
        <van-swipe-item v-for="(item, index) in oil_card_list" :key="index">
          <div class="oli-card-item">
            <img
              class="oli-card-bg"
              :src="
                item.oil_type == 'sinopec'
                  ? chinasinopecbgicon
                  : chinapetroleumbgicon
              "
              alt=""
            />
            <div class="oli-card-con">
              <div class="card-first-div">
                <div>
                  <img
                    class="oli-card-logo"
                    :src="
                      item.oil_type == 'sinopec'
                        ? chinasinopeclogo
                        : chinapetroleumlogo
                    "
                    alt=""
                  />
                  <span class="oli-card-name">{{
                    item.oil_type == "sinopec"
                      ? "中国石化加油卡"
                      : "中国石油加油卡"
                  }}</span>
                </div>
                <div>
                  <span class="oli-card-nickname">{{ item.remark }}</span>
                  <span
                    class="oli-card-setting"
                    @click="goPage('/new-oli/cardmanage')"
                    ><img :src="chinapetroleumsetting" alt=""
                  /></span>
                </div>
              </div>
              <div class="card-second-div">
                <div class="oil-tag">Card number</div>
                <div class="oil-number">
                  {{ HandlecardNumber(item.gas_card_number) }}
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
        <template #indicator>
          <div class="new-oil-indicator">
            <span
              v-for="(item, index) in oil_card_list"
              :key="index"
              :class="{ 'indicator-activate': card_index == index }"
            ></span>
          </div>
        </template>
      </van-swipe>
    </div>
    <div class="new-oil-second-div">
      <div>充值金额</div>
      <div @click="oil_pup_show = !oil_pup_show">
        <img :src="newoilinfoicon" alt="" /><span>充值说明</span>
      </div>
    </div>
    <div class="new-oil-three-div">
      <div
        :class="{ 'amount-activate': amount_index == index }"
        v-for="(item, index) in order_amount_list"
        :key="index"
        @click="changeAmount(item, index)"
      >
        {{ item.price }}元
      </div>
    </div>
    <div
      v-show="order_amount_list.length == 0 && order_amount_res"
      class="new-oil-amout-empty-div"
    >
      <img :src="rechargeamountemptyicon" alt="" /><span
        >油卡维护中,请稍后再试</span
      >
    </div>
    <div class="new-oil-recharge-bottom" :class="{ bm34: isIosX }">
      <div class="recharge-btn" @click="goPay"><span>立即充值</span></div>
      <div class="recharge-agreement-div" @click="ischecked = !ischecked">
        <span v-show="!ischecked"></span>
        <img v-show="ischecked" :src="rechargeagreementcheckicon" alt="" />
        <span>我已阅读同意</span
        ><span @click.stop="goPage('/new-oli/rechargeAgreement')"
          >《销巴生活卡充值协议》</span
        >
      </div>
    </div>
    <div
      class="oil-pup-div"
      v-show="oil_pup_show"
      @click="oil_pup_show = false"
    >
      <div class="oil-pup-con">
        <div>充值说明</div>
        <div>
          <p v-for="(item, index) in recharge_descriptions" :key="index">
            {{ item }}
          </p>
        </div>
      </div>
    </div>
    <centerrscreenloading :loading="page_loading" />
  </div>
</template>

<script>
import navbar from "../components/nav-bar.vue";
import centerrscreenloading from "../components/centerrscreen-loading.vue";
import {
  getThirdrechargeOilBindList,
  getThirdrechargeOilDenominationList,
  getThirdrechargeOilChargeDescription,
} from "../api/index";
import { Toast } from "vant";
export default {
  components: { navbar, centerrscreenloading },
  data() {
    return {
      newoilcardbackicon: require("@/assets/recharge/new-oilcard-back-icon.png"),
      newoilcardrighticon: require("@/assets/recharge/new-oilcard-right-icon.png"),
      chinapetroleumbgicon: require("@/assets/recharge/china-petroleum-bg-icon.png"),
      chinapetroleumlogo: require("@/assets/recharge/china-petroleum-logo.png"),
      chinasinopecbgicon: require("@/assets/recharge/china-sinopec-bg-icon.png"),
      chinasinopeclogo: require("@/assets/recharge/china-sinopec-logo.png"),
      chinapetroleumsetting: require("@/assets/recharge/china-petroleum-setting.png"),
      newoilinfoicon: require("@/assets/recharge/new-oil-info-icon.png"),
      rechargeagreementcheckicon: require("@/assets/recharge/recharge-agreement-check-icon.png"),
      rechargeamountemptyicon: require("@/assets/recharge/recharge-amount-empty-icon.png"),
      isIosX: false,
      amount_index: -1,
      card_index: 0,
      activation_card_index: 0,
      oil_pup_show: false,
      ischecked: false,
      order_amount_list: [],
      order_amount_res: false, // 面额列表是否请求完成
      oil_card_list: [],
      page_loading: true,
      charge_id: "",
      channel_id: "",
      charge_amount: "",
      goods_id: "",
      item_id: "",
      charge_account: "",
      oil_type: "",
      recharge_descriptions: "",
    };
  },
  async created() {
    this.isIosX = this.isIphoneX();
    await getThirdrechargeOilBindList({ oil_type: "all" }).then((res) => {
      this.oil_card_list = res.list.data;
      if (this.oil_card_list.length == 0) {
        return;
      }
      if (this.$route.query.card_id) {
        this.oil_card_list.map((item, index) => {
          if (item.id == this.$route.query.card_id) {
            this.activation_card_index = index;
            this.card_index = index;
          }
        });
      }
      this.charge_id = this.oil_card_list[this.card_index].charge_id;
      this.charge_account = this.oil_card_list[this.card_index].gas_card_number;
      this.oil_type = this.oil_card_list[this.card_index].oil_type;
      this.getAmountData();
    });
    await getThirdrechargeOilChargeDescription({
      charge_id: "14",
      channel_id: "8",
    }).then((res) => {
      for (let item of res.data) {
        if (item.title == "油卡充值说明") {
          this.recharge_descriptions = item.description
            .split("\n")
            .map((item) => `${item}`);
        }
      }
    });
  },
  methods: {
    changeCardIndex(index) {
      this.card_index = index;
      this.charge_account = this.oil_card_list[index].gas_card_number;
      if (this.charge_id != this.oil_card_list[index].charge_id) {
        this.charge_id = this.oil_card_list[index].charge_id;
        this.oil_type = this.oil_card_list[index].oil_type;
        this.page_loading = true;
        this.order_amount_res = false;
        this.getAmountData();
      }
    },
    changeAmount(item, index) {
      this.amount_index = index;
      this.goods_id = item.id;
      this.charge_amount = item.price;
      this.item_id = item.item_id;
      this.channel_id = this.order_amount_list[index].channel_id;
    },
    async getAmountData() {
      await getThirdrechargeOilDenominationList({
        charge_id: this.charge_id,
      }).then((res) => {
        this.amount_index = -1;
        this.order_amount_list = res;
        this.order_amount_res = true;
        if (this.order_amount_list.length) {
          this.channel_id = this.order_amount_list[0].channel_id;
          this.amount_index = 0;
          this.charge_amount = this.order_amount_list[0].price;
          this.goods_id = this.order_amount_list[0].id;
          this.item_id = this.order_amount_list[0].item_id;
        }
        this.page_loading = false;
      });
    },
    HandlecardNumber(number) {
      let new_number = "";
      for (let index in number) {
        new_number += number[index];
        if (index % 4 == 3) {
          new_number += " ";
        }
      }
      return new_number;
    },
    goPay() {
      if (this.amount_index == -1) {
        return Toast("请选择充值金额");
      }
      if (!this.ischecked) {
        return Toast("请同意销巴生活充值协议");
      }
      this.$router.push({
        path: "/new-oli/orderconfirm",
        query: {
          charge_id: this.charge_id, //类型：String  必有字段  备注：charge_id
          channel_id: this.channel_id, //类型：String  必有字段  备注：channel_id
          goods_id: this.goods_id, //类型：String  必有字段  备注：面额id
          charge_account: this.charge_account, //类型：String  必有字段  备注：油卡账号
          charge_amount: this.charge_amount, //类型：String  必有字段  备注：充值金额
          oil_type: this.oil_type,
          item_id: this.item_id,
        },
      });
    },
    goPage(path) {
      this.$router.push({
        path,
      });
    },
    goBack() {
      if (this.$route.query.card_id) {
        this.$router.go(-2);
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style lang="less">
.new-oil-recharge-body {
  .oil-pup-div {
    .oil-pup-con {
      top: 320px !important;
      transform: translateX(-50%) !important;
    }
  }
}
</style>
<style lang="less" scoped>
.new-oil-recharge-body {
  padding-top: 88px;
  min-height: calc(100vh - 88px);

  .new-oil-recharge-nav {
    padding-top: 44px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
  }

  .new-oil-card-div {
    margin-top: 16px;
    height: 166px;
    padding: 0 16px;

    .oli-card-item {
      height: 166px;
      position: relative;

      .oli-card-bg {
        position: absolute;
        left: 0;
        top: 0;
        height: 166px;
        width: 100%;
        z-index: 1;
      }

      .oli-card-con {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;

        .card-first-div {
          padding: 18px 0 40px 9px;
          display: flex;
          justify-content: space-between;
          height: 26px;
          width: calc(100% - 38px);

          .oli-card-logo {
            width: 25px;
            height: 26px;
            margin-right: 9px;
          }

          .oli-card-name {
            font-size: 14px;
            font-weight: 500;
            text-align: left;
            color: #ffffff;
            line-height: 20px;
            letter-spacing: 1.1px;
            text-shadow: 1px 0px 0px 0px #f5621c;
            margin-top: 3px;
            display: inline-block;
            vertical-align: top;
          }

          .oli-card-nickname {
            display: inline-block;
            vertical-align: top;
            margin-top: 5px;
            font-size: 12px;
            font-weight: 400;
            text-align: right;
            color: #ffffff;
            line-height: 17px;
            margin-right: 12px;
          }

          .oli-card-setting {
            position: absolute;
            display: inline-block;
            top: 24px;
            right: 16px;
            width: 16px;
            height: 16px;

            img {
              width: 16px;
              height: 16px;
            }
          }
        }

        .card-second-div {
          padding-left: 9px;

          .oil-tag {
            opacity: 0.6;
            font-size: 10px;
            font-weight: 400;
            text-align: left;
            color: #ffffff;
            line-height: 12px;
            letter-spacing: 0.33px;
            margin-bottom: 3px;
          }

          .oil-number {
            font-size: 18px;
            font-weight: 600;
            text-align: left;
            color: #ffffff;
            line-height: 25px;
            letter-spacing: 0.59px;
          }
        }
      }
    }

    .new-oil-indicator {
      height: 3px;
      font-size: 0;
      display: flex;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      overflow-x: auto;
      width: calc(100vw - 32px);
      margin-top: 5px;
      justify-content: center;

      span {
        display: inline-block;
        flex: 1;
        max-width: 36px;
        height: 3px;
        background: #eaeaea;
        border-radius: 2px;
      }

      .indicator-activate {
        background: linear-gradient(135deg, #ff792d, #f8541a);
      }
    }
  }

  .new-oil-second-div {
    height: 22px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    padding: 0 16px;

    div {
      &:first-child {
        font-size: 16px;
        font-weight: 600;
        text-align: left;
        color: #333333;
        line-height: 22px;
      }

      &:last-child {
        display: flex;
        align-items: center;

        img {
          width: 12px;
          height: 12px;
        }

        span {
          display: inline-block;
          opacity: 0.34;
          font-size: 12px;
          font-weight: 400;
          text-align: right;
          color: #333333;
          line-height: 17px;
          margin-left: 4px;
        }
      }
    }
  }

  .new-oil-three-div {
    display: flex;
    flex-wrap: wrap;
    padding: 12px 16px 0;

    div {
      width: calc((100vw - 32px - 24px - 6px) / 3);
      margin-right: 12px;
      border: 1px solid #d8d8d8;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      color: #676767;
      line-height: 50px;
      height: 50px;
      margin-bottom: 14px;

      &:nth-child(3n) {
        margin-right: 0;
      }
    }

    .amount-activate {
      color: #fa760e;
      border: 1px solid #f9740d;
    }
  }

  .new-oil-amout-empty-div {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      height: 25px;
      width: 25px;
      vertical-align: top;
    }

    span {
      margin: 0 0 0 10px;
      opacity: 0.4;
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #333333;
      height: 17px;
    }
  }

  .new-oil-recharge-bottom {
    text-align: center;
    position: absolute;
    bottom: 33px;
    left: 0;
    width: 100vw;

    .recharge-btn {
      width: calc(100% - 60px);
      margin: 0 30px;
      height: 25px;
      background: linear-gradient(135deg, #fa770d, #f44d19);
      border-radius: 25px;
      text-align: center;
      padding: 10px 0;

      span {
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 25px;
      }
    }

    .recharge-agreement-div {
      margin-top: 10px;

      img {
        width: 12px;
        height: 12px;
        position: relative;
        top: 1px;
      }

      span {
        display: inline-block;

        &:first-child {
          width: 10px;
          height: 10px;
          background: #ffffff;
          border: 1px solid #cfcfcf;
          border-radius: 50%;
          position: relative;
          top: 1px;
        }

        &:nth-child(3),
        &:nth-child(4) {
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #c8c8c8;
          line-height: 17px;
        }

        &:nth-child(3) {
          margin-left: 4px;
        }

        &:last-child {
          color: #358cf9;
        }
      }
    }
  }

  .oil-pup-div {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 2;

    .oil-pup-con {
      opacity: 0.8;
      background: #000000;
      border-radius: 20px;
      width: calc(100vw - 32px);
      position: absolute;
      z-index: 2;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 10px 0;

      div {
        &:nth-child(1) {
          font-size: 14px;
          font-weight: 500;
          text-align: center;
          color: #ffffff;
          line-height: 20px;
          text-align: center;
          margin: 0 0 10px;
        }

        &:nth-child(2) {
          padding: 0 21px;
          max-height: 40vh;
          overflow-y: auto;

          p {
            font-size: 14px;
            font-weight: 500;
            text-align: left;
            color: #ffffff;
            line-height: 20px;
            margin-bottom: 4px;
          }
        }
      }
    }
  }

  .bm34 {
    bottom: 67px;
  }
}
</style>
